import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/login/login.js';
import LoginClienteAuth0 from './pages/login/loginClienteAuth0.js';
import ProtectedRoute from './pages/protectedRoute/protectedRoute.js';
import { LoginProvider } from './context/loginContext.js';
import { GlobalProvider } from './context/globalContext.js';
import MainLayout from './pages/layout/layout.js';
import { ConfigProvider } from 'antd';
import { SucursalProvider } from './context/sucursalContext.js';
import { CarritoProvider } from './context/carritoContext.js';
import { NotificacionProvider } from './context/notificacionContext.js';
// Empresa
import CHomeEmpresa from './pages/users/empresa/home/home-empresa.js';
import CConfiguracionEmpresa from './pages/users/empresa/configuracion/configuracion-empresa.js';
import CListaSucursalesEmpresa from './pages/users/empresa/sucursales/lista-sucursal-empresa.js';
import CSucursalEmpresa from './pages/users/empresa/sucursales/sucursal-empresa.js';
import CListaUsuariosEmpresa from './pages/users/empresa/usuarios/lista-usuarios-empresa.js';
import CUsuarioEmpresa from './pages/users/empresa/usuarios/usuarios-empresa.js';
import CCargarArticuloEmpresa from './pages/users/empresa/ariculo/carga-articulo-empresa.js';
import CListaArticulosEmpresa from './pages/users/empresa/ariculo/lista-articulo-empresa.js';
import CCategoriaEmpresa from './pages/users/empresa/categorias/CCategoriasEmpresa.js';

//Sucursal
import CHomeSucursal from './pages/users/sucursal/home/home-sucursal.js';
import CListaArticulosEmpresaSucursal from './pages/users/sucursal/articulos/articulo-empresa.js';
import CListaArticulosHabilitadosSucursal from './pages/users/sucursal/articulos/articulos-sucursal.js';
import CDetalleVistaArticulo from './pages/users/sucursal/articulos/detalle-articulo-sucursal.js';
import CPedidosSucursal from './pages/users/sucursal/pedidos/CPedidosSucursal.js';
import CCarruselSucursal from './pages/users/sucursal/carrusel/CCarruselSucursal.js';

//Cliente
import CHomeCliente from './pages/users/cliente/home-cliente.js';
import CDatosCliente from './pages/users/cliente/datos/CDatosCliente.js';
import CCarritoCliente from './pages/users/cliente/carrito/CCarritoCliente.js';
import CFinalizarCarrito from './pages/users/cliente/carrito/CFinalizarCarrito.js';
import CPedidosCliente from './pages/users/cliente/pedidos/CPedidosCliente.js';

//Publico
import CSeleccionSucursal from './pages/users/publico/CSeleccionSucursal.js';
import CInicio from './pages/users/publico/inicio/CInicio.js';
import CDetalleArticuloInicio from './pages/users/publico/inicio/CDetalleArticuloInicio.js';

function App() {
  const [themeConfig, setThemeConfig] = useState({
    colorPrimary: '#52c41a',
    borderRadius: 4,
    Button: {
      colorPrimary: '#52c41a',
      algorithm: true,
    },
  });

  // Registrar visita una vez por sesión; no espera respuesta ni bloquea la UI
  useEffect(() => {
    if (sessionStorage.getItem('visitaRegistrada')) return;
    sessionStorage.setItem('visitaRegistrada', '1');

    const url = `${process.env.REACT_APP_API_URL}/visitas`;
    try {
      const enviada = typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(url);
      if (!enviada) {
        fetch(url, { method: 'POST', keepalive: true }).catch(() => {});
      }
    } catch (_) {
      // Ignorar: la visita no debe afectar el uso del sistema
    }
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: themeConfig.colorPrimary,
          borderRadius: themeConfig.borderRadius,
        },
        components: {
          Button: {
            colorPrimary: themeConfig.Button?.colorPrimary,
            algorithm: themeConfig.Button?.algorithm,
          },
        },
      }}
    >
      <LoginProvider>
          <GlobalProvider>
            <SucursalProvider>
                      <CarritoProvider>
                        <NotificacionProvider>
              <Router >
                <Routes>
                  <Route path="/login" element={<LoginClienteAuth0 />} />
                  <Route path="/admin" element={<Login />} />
                  <Route path="/login-empresa" element={<Login />} />
                  <Route path="/" element={<CSeleccionSucursal />} />
                  <Route
                    path="/detalle-articulo-inicio"
                    element={
                      <MainLayout>
                        <CDetalleArticuloInicio />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/home"
                    element={
                      <MainLayout>
                        <CInicio />
                      </MainLayout>
                    }
                  />

                  <Route
                    path="/home-cliente"
                    element={
                      <MainLayout>
                        <CHomeCliente />
                      </MainLayout>
                    }
                  />

                  {/* Rutas protegidas */}
                  <Route
                    path="/home-empresa"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CHomeEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/configuracion-empresa"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CConfiguracionEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/lista-sucursal-empresa"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CListaSucursalesEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/sucursal-empresa/editar/:id"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CSucursalEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/sucursal-empresa/nueva"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CSucursalEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/lista-usuarios-empresa"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CListaUsuariosEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/usuarios-empresa/editar/:id"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CUsuarioEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/usuarios-empresa/nueva"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CUsuarioEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/nuevo-articulo-empresa"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CCargarArticuloEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/lista-articulo-empresa"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CListaArticulosEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/categorias-empresa"
                    element={
                      <ProtectedRoute allowedRoles={['Empresa']}>
                        <MainLayout>
                          <CCategoriaEmpresa />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/home-sucursal"
                    element={
                      <ProtectedRoute allowedRoles={['Sucursal']}>
                        <MainLayout>
                          <CHomeSucursal />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/lista-articulos-empresa-sucursal"
                    element={
                      <ProtectedRoute allowedRoles={['Sucursal']}>
                        <MainLayout>
                          <CListaArticulosEmpresaSucursal />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/articulos-habilitados-sucursal"
                    element={
                      <ProtectedRoute allowedRoles={['Sucursal']}>
                        <MainLayout>
                          <CListaArticulosHabilitadosSucursal />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/detalle-articulo-sucursal/:id"
                    element={
                      <ProtectedRoute allowedRoles={['Sucursal']}>
                        <MainLayout>
                          <CDetalleVistaArticulo />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/pedidos-sucursal"
                    element={
                      <ProtectedRoute allowedRoles={['Sucursal']}>
                        <MainLayout>
                          <CPedidosSucursal />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/carrusel-sucursal"
                    element={
                      <ProtectedRoute allowedRoles={['Sucursal']}>
                        <MainLayout>
                          <CCarruselSucursal />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/datos-cliente"
                    element={
                      <ProtectedRoute allowedRoles={['Cliente']}>
                        <MainLayout>
                          <CDatosCliente />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/carrito-cliente"
                    element={
                      <ProtectedRoute allowedRoles={['Cliente']}>
                        <MainLayout>
                          <CCarritoCliente />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/finalizar-carrito"
                    element={
                      <ProtectedRoute allowedRoles={['Cliente']}>
                        <MainLayout>
                          <CFinalizarCarrito />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/pedidos-cliente"
                    element={
                      <ProtectedRoute allowedRoles={['Cliente']}>
                        <MainLayout>
                          <CPedidosCliente />
                        </MainLayout>
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Router>
                        </NotificacionProvider>
              </CarritoProvider>
            </SucursalProvider>
          </GlobalProvider>
      </LoginProvider>
    </ConfigProvider>
  );
}

export default App;
